import { createElement, lazy, Suspense, type ComponentType } from 'react';

type ConsoleLoader = () => Promise<{ default: ComponentType }>;

/**
 * Loader of the Compute full-window instance console (the VNC / Guacamole popup), which lives in a
 * feature package. The console popup dispatcher is a page and may not import a package or the
 * composition root, so the root fills this object (`src/app/register-compute.tsx`) and the page reads
 * it. A loader, not a component: `lazy` stays out of the entry chunk until the console is rendered.
 */
export const computeConsoles: {
  /** The instance console (`createComputeModule(...).loadInstanceConsole`). */
  loadInstanceConsole?: ConsoleLoader;
} = {};

let Lazy: ComponentType | undefined;

/** The Compute full-window instance console, loaded when first rendered. */
export function ComputeInstanceConsole() {
  if (!Lazy) {
    const load = computeConsoles.loadInstanceConsole;
    if (!load) throw new Error('Compute: the instance console was rendered before register-compute filled computeConsoles');
    Lazy = lazy(load);
  }
  return createElement(Suspense, { fallback: null }, createElement(Lazy));
}
